"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROVIDER_MONEY_DECIMALS = void 0;
exports.roundMoney = roundMoney;
exports.snapMoney = snapMoney;
exports.subtractMoney = subtractMoney;
/** Round to 2 decimal places (currency cents). Avoids IEEE float display like 34859.840000000004. */
function roundMoney(value) {
    return Math.round((Number(value) || 0) * 100) / 100;
}
/** Finmo quotes processing fees past cents (observed up to 6 decimal places). */
exports.PROVIDER_MONEY_DECIMALS = 6;
/**
 * Snap a provider amount onto a fixed decimal scale so binary float dust
 * (112.192 - 109.6 → 2.5919999999999987) does not leak into a transfer.
 * This does not round to cents.
 */
function snapMoney(value, decimalPlaces = exports.PROVIDER_MONEY_DECIMALS) {
    const n = Number(value);
    if (!Number.isFinite(n))
        return 0;
    const factor = 10 ** decimalPlaces;
    return Math.round(n * factor) / factor;
}
/** Subtract two money amounts on a fixed decimal scale. */
function subtractMoney(minuend, subtrahend, decimalPlaces = exports.PROVIDER_MONEY_DECIMALS) {
    const factor = 10 ** decimalPlaces;
    return (Math.round(minuend * factor) - Math.round(subtrahend * factor)) / factor;
}
